module.exports = __webpack_public_path__ + "assets/193a8d1a8cee8cddf1986f844c1371e2.mp3";